import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { ActionButtonDefinition, ActionButtonVariant } from '@uigy/shared/components/ui-buttons-action-bar/models';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { UiSectionTitleComponent } from '@uigy/shared/components/ui-section-title/ui-section-title.component';

@Component({
  selector: 'app-ui-accordion',
  imports: [
    UiSectionTitleComponent,
  ],
  templateUrl: './ui-accordion.component.html',
  styleUrl: './ui-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiAccordionComponent {
  public title = input.required<string>();
  public subtitle = input<string>();
  public expanded = model<boolean>(false);

  public isExpanded = computed(() => this.expanded());

  public toggleExpanded(): void {
    this.expanded.update(value => !value);
  }

  public actionButtons = computed<ActionButtonDefinition[]>(() => {
    return [
      {
        variant: ActionButtonVariant.icon,
        icon: this.isExpanded() ? IconsEnum.chevron_up : IconsEnum.chevron_down,
        action: (): void => this.toggleExpanded(),
      },
    ];
  });
}
